import { useState } from "react";
import { faqs } from "@/mocks/comicData";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="w-full py-14 md:py-20">
      <div className="mx-auto max-w-3xl px-4 md:px-6">
        <div className="text-center">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs text-accent-700">
            <i className="ri-question-line"></i>常见问题
          </span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            关于追更，你想知道的都在这里
          </h2>
        </div>

        <div className="mt-9 space-y-3">
          {faqs.map((f, i) => {
            const open = openIdx === i;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-lg border transition-colors ${
                  open ? "border-primary-300 bg-primary-50/60" : "border-background-200 bg-background-100/60"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(open ? -1 : i)}
                  className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                  aria-expanded={open}
                >
                  <h3 className="flex items-center gap-2.5 font-medium text-foreground-950">
                    <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-600 font-heading text-xs text-background-50">
                      Q
                    </span>
                    {f.q}
                  </h3>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-background-50 text-foreground-700 transition-transform ${
                      open ? "rotate-180" : ""
                    }`}
                  >
                    <i className="ri-arrow-down-s-line text-lg"></i>
                  </span>
                </button>
                {open && (
                  <div className="px-5 pb-5 pl-[52px]">
                    <p className="text-sm leading-relaxed text-foreground-700">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}